import gallery1Img from "../assets/images/gallery-images/Aisha-Image.jpg";
import gallery2Img from "../assets/images/gallery-images/story-gallery-img5.png";
import S3CLink from "../components/S3CLink";

const galleryList = [
    {
        id: 0,
        caption: (
          <p>
            <span className='gallery-caption'>Photo: Woman receiving support throughout her maternal health journey </span> 
            <strong className='gallery-coalition-title'> The Impact of Maternal Health Influencers</strong>
            Alone and struggling with early motherhood, a 20-year-old woman encountered a dedicated Maternal Health Influencer. Maternal Health influencers are community members that are trained to promote maternal health education. The influencer recognized the young mother’s distress and offered support. Throughout her pregnancy, the influencer provided emotional guidance, accompanied her to medical appointments, and shared crucial education. In September, the woman delivered a healthy baby.
          </p>
        ),
        image: gallery1Img
      },
      {
        id: 1,
        caption: (
          <p>
            <span className='gallery-caption'>Photo: Women using NaviHealth to share feedback </span> 
            <strong className='gallery-coalition-title'>The Importance of Elevating Women’s Voices</strong>
            The use of NaviHealth to harness women’s experiences of care and utilizing their feedback to improve patient care is a priority for Project Aisha. A patient who visited a primary health care centre expressed her negative feedback with the management of her baby on the NaviHealth mobile application. A closer look into her feedback found that lack of information provided by health care workers and poor communication contributed towards the patient’s poor experience. While the child was managed in adherence to protocol as evident with the child’s improved health, the mother was not adequately informed. The mother appreciated the follow-up and committed to continued use of the feedback platform.
          </p>
        ),
        image: gallery2Img
      }
];

export default galleryList;
